export default __webpack_public_path__ + "static/media/tsLogo.98f6e051.svg";